/* GIESTO Fırsatları in the bag (YUN-188, until 15 November 2026, Istanbul; the owner
   started them on the evening of 25 October instead of on the 26th).
   Shopify's automatic discounts do the discounting (CAMPAIGN in
   scripts/shopify/firsat-campaign-operations.mjs); this only tells the cart and the
   add-to-cart confirmation where the bag stands:
   - Sepette Fırsat: items the team picks into GIESTO FIRSATLARI (since 2026-10-29; before,
     all of `indirim`), an extra 20% with two and 30% with three or more.
   - Basic Ayrıcalığı: a free Kısa Kol Regular Fit t-shirt from 4.000 TL of basic™ items.
   Campaigns never combine, so Shopify applies the bag's single best saving; when more
   than one is reached, a note names the one applied.

   Basic Ayrıcalığı was switched off on 2026-10-26; its rows show only when the theme
   setting `giesto_basic_gift_campaign` is on again (the callers pass `gift`).

   Product flags come from sections/giesto-tier-campaign.liquid: "i" in GIESTO FIRSATLARI,
   "b" in `basic`, "g" one of the free t-shirts. Amounts are in kuruş, like cart.js. */
(() => {
  // YUN-212 quotes also arrive through filters and editorial lazy loading.
  // A custom element checks each mounted quote without observing the whole
  // document, and expires it even when the shopper leaves the page open.
  if (typeof customElements !== 'undefined' && !customElements.get('giesto-sale-quantity-price')) {
    customElements.define('giesto-sale-quantity-price', class extends HTMLElement {
      connectedCallback() { this.refresh(); }
      disconnectedCallback() { clearTimeout(this.expiry); }
      refresh() {
        clearTimeout(this.expiry);
        const start = Date.parse(this.dataset.startsAt), end = Date.parse(this.dataset.endsAt), now = Date.now();
        const amount = this.querySelector('[data-sale-quantity-value]')?.textContent.trim();
        this.hidden = !amount || !Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end;
        if (amount && now < end) this.expiry = setTimeout(() => this.refresh(), Math.min((now < start ? start : end) - now + 50, 2147483647));
      }
    });
  }
  if (window.GiestoFirsat) return;
  const WINDOW = [Date.parse('2026-10-25T20:00:00Z'), Date.parse('2026-11-15T21:00:00Z')];
  const SALE = {title: 'Sepette Fırsat', steps: [[2, 20], [3, 30]], url: '/collections/i%CC%87ndi%CC%87ri%CC%87m-2'};
  const GIFT = {title: 'Basic Ayrıcalığı', minimum: 400000, url: '/products/kisa-kol-regular-fit-beyaz-t-shirt'};
  const TIER = 'Sonbahar/Kış sepet indirimi';

  const lines = cart => cart?.items || [];
  const has = (flags, item, flag) => (flags.get(String(item.product_id)) || '').includes(flag);
  // What Shopify actually took off for a campaign, line and cart level.
  function applied(cart, prefix) {
    const line = lines(cart).reduce((sum, item) => sum + (item.line_level_discount_allocations || [])
      .filter(allocation => allocation.discount_application?.title?.startsWith(prefix))
      .reduce((total, allocation) => total + Number(allocation.amount || 0), 0), 0);
    return line + (cart?.cart_level_discount_applications || [])
      .filter(application => application.title?.startsWith(prefix))
      .reduce((sum, application) => sum + Number(application.total_allocated_amount || 0), 0);
  }
  const unit = item => Number(item.original_price ?? (item.original_line_price / Math.max(1, item.quantity)) ?? 0);

  /* Where the bag stands, or null until every product in it is known. The free
     t-shirt is not part of the 4.000 TL: one of them is left out of the basic™ total. */
  function quote(cart, flags) {
    const items = lines(cart);
    if (!items.length || items.some(item => !flags.has(String(item.product_id)))) return null;
    const count = items.filter(item => has(flags, item, 'i')).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    const gifts = items.filter(item => has(flags, item, 'g'));
    const giftUnit = gifts.length ? Math.min(...gifts.map(unit)) : 0;
    const basic = items.filter(item => has(flags, item, 'b'))
      .reduce((sum, item) => sum + Number(item.original_line_price ?? unit(item) * item.quantity), 0) - giftUnit;
    return {
      sale: count ? {count, step: SALE.steps.filter(([at]) => count >= at).at(-1) || null,
        next: SALE.steps.find(([at]) => count < at) || null, applied: applied(cart, SALE.title)} : null,
      gift: basic > 0 || gifts.length ? {total: Math.max(0, basic), missing: Math.max(0, GIFT.minimum - basic),
        inBag: gifts.length > 0, applied: applied(cart, GIFT.title)} : null,
      tierApplied: applied(cart, TIER) > 0,
    };
  }

  /* The rows to show, as text parts: a string, {strong} or {href, text}.
     `tierReached` is whether the Sonbahar/Kış tiers are reached, which the caller knows.
     `focus` limits the rows to the campaigns an added product belongs to; `gift` says
     whether Basic Ayrıcalığı is on. */
  function rows(state, {tr, money, root = '/', tierReached = false, focus = null, gift: giftOn = false}) {
    if (!state) return {rows: [], note: null};
    const text = (turkish, english) => tr ? turkish : english;
    const link = path => root.replace(/\/$/, '') + path;
    const result = [];
    const sale = state.sale, gift = giftOn ? state.gift : null;
    if (sale && (!focus || focus.includes('i'))) {
      const [, percent] = sale.step || [];
      const more = sale.next ? sale.next[0] - sale.count : 0;
      let parts;
      if (!sale.step) parts = text(
        [{strong: more + ' seçili ürün'}, ' daha ekleyin, sepette ', {strong: 'ekstra %' + sale.next[1]}, ' indirim kazanın. ', {href: link(SALE.url), text: 'Seçili ürünler'}],
        ['Add ', {strong: more + ' more selected item' + (more === 1 ? '' : 's')}, ' for an ', {strong: 'extra ' + sale.next[1] + '% off'}, '. ', {href: link(SALE.url), text: 'Shop the selection'}]);
      else if (sale.applied) parts = text(
        [{strong: 'Ekstra %' + percent}, ' indirim uygulandı', ...(sale.next ? [' · ', {strong: more + ' seçili ürün'}, ' daha ekleyin, ', {strong: '%' + sale.next[1]}, ' olsun.'] : ['!'])],
        [{strong: 'Extra ' + percent + '% off'}, ' applied', ...(sale.next ? [' · add ', {strong: more + ' more'}, ' for ', {strong: sale.next[1] + '%'}, '.'] : ['!'])]);
      else parts = text(
        [{strong: 'Ekstra %' + percent}, ' indirim hakkı kazandınız.'],
        ['You have earned an ', {strong: 'extra ' + percent + '% off'}, '.']);
      // Labels are written in capitals: CSS uppercasing in Turkish would spell "BASİC".
      result.push({key: 'sale', label: text('SEPETTE FIRSAT', 'BAG DEAL'), parts, reached: Boolean(sale.step), applied: sale.applied > 0});
    }
    if (gift && (!focus || focus.includes('b') || focus.includes('g'))) {
      let parts;
      if (gift.missing > 0) parts = text(
        ['basic™ ürünlerinden ', {strong: money(gift.missing)}, ' daha ekleyin, ', gift.inBag ? 'kısa kollu tişörtünüz hediye olsun.' : {strong: 'kısa kollu tişört hediye.'}],
        ['Add ', {strong: money(gift.missing)}, ' more basic™ for ', gift.inBag ? 'your short-sleeve T-shirt free.' : {strong: 'a free short-sleeve T-shirt.'}]);
      else if (!gift.inBag) parts = text(
        [{strong: 'Kısa kollu tişört hediye'}, ' kazandınız! ', {href: link(GIFT.url), text: 'Hediye tişörtünüzü seçin'}],
        ['You have earned ', {strong: 'a free short-sleeve T-shirt'}, '! ', {href: link(GIFT.url), text: 'Choose your T-shirt'}]);
      else if (gift.applied) parts = text(
        ['Hediye tişörtünüz sepette: ', {strong: money(0)}, '.'],
        ['Your free T-shirt is in your bag: ', {strong: money(0)}, '.']);
      else parts = text(
        [{strong: 'Hediye tişört'}, ' hakkı kazandınız.'],
        ['You have earned ', {strong: 'a free T-shirt'}, '.']);
      result.push({key: 'gift', label: text('BASIC AYRICALIĞI', 'BASIC PRIVILEGE'), parts, reached: gift.missing === 0 && gift.inBag, applied: gift.applied > 0});
    }
    // Only when two campaigns compete for the same bag does the rule need saying. An earned
    // t-shirt competes before it is added: adding it can take the place of a tier.
    const reached = [tierReached, Boolean(sale?.step), Boolean(gift && gift.missing === 0)].filter(Boolean).length;
    let note = null;
    if (reached > 1) {
      const winner = state.tierApplied ? text('Sonbahar/Kış sepet indirimi', 'Autumn/Winter bag discount')
        : sale?.applied ? text('Sepette Fırsat', 'Bag deal') : gift?.applied ? text('Basic Ayrıcalığı', 'Basic privilege') : null;
      note = winner
        ? text(['Kampanyalar birleştirilmez; sepetinize en avantajlı olan ', {strong: winner}, ' uygulandı.'], ['Offers do not combine; your bag gets the best one: ', {strong: winner}, '.'])
        : text(['Kampanyalar birleştirilmez; sepetinize en avantajlı olanı uygulanır.'], ['Offers do not combine; your bag gets the best one.']);
    }
    return {rows: result, note};
  }

  // Shopify's discount names, as the totals show them. The totals are set in capitals,
  // so "BASIC" is written that way: Turkish uppercasing would turn "Basic" into "BASİC".
  function label(title, text) {
    if (title?.startsWith(SALE.title)) {
      const percent = title.match(/%(\d+)/)?.[1];
      return text('Sepette Fırsat' + (percent ? ' · ekstra %' + percent : ''), 'Bag deal' + (percent ? ' · extra ' + percent + '%' : ''));
    }
    if (title?.startsWith(GIFT.title)) return text('BASIC Ayrıcalığı · hediye tişört', 'Basic privilege · free tee');
    return null;
  }

  // Product pages render the Fırsatlar rows server-side (snippets/giesto-product-campaigns);
  // a page cached past the end drops them, and the box goes when nothing is left in it.
  const now = Date.now();
  const touched = new Set();
  for (const row of document.querySelectorAll('[data-firsat-until]')) {
    if (now < Date.parse(row.dataset.firsatUntil)) continue;
    touched.add(row.closest('[data-gap-campaigns], .gs-campaign-sheet'));
    row.remove();
  }
  for (const box of touched) {
    const rows = box ? [...box.querySelectorAll('.gap__campaign')] : [];
    if (!rows.length) {box?.remove(); continue;}
    if (rows.length < 2) box.querySelector('[data-gap-campaigns-note]')?.remove();
    // The closed row names the first campaign left and counts the others.
    const headline = box.querySelector('[data-gap-campaigns-headline]');
    const more = box.querySelector('[data-gap-campaigns-more]');
    headline?.replaceChildren(rows[0].querySelector('.gap__campaign-short')?.textContent || '', ...(more && rows.length > 1 ? [more] : []));
    if (more) more.textContent = ' · +' + (rows.length - 1) + (document.documentElement.lang.startsWith('tr') ? ' kampanya' : ' more');
  }

  window.GiestoFirsat = {
    active: (now = Date.now()) => now >= WINDOW[0] && now < WINDOW[1],
    quote, rows, label, applied,
    giftTitle: GIFT.title,
    flags: ['i', 'b', 'g'],
  };
})();
